import Link from 'next/link'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'

const CONTACT_EMAIL = 'onare@onadev.net'
const LAST_UPDATED = 'April 16, 2025'

const Section = ({ title, children }) => (
  <Box sx={{ mb: 3 }}>
    <Typography variant='h6' component='h2' color='primary' gutterBottom>
      {title}
    </Typography>
    {children}
  </Box>
)

const Terms = () => {
  return (
    <>

      <Grid container spacing={6}>
        <Grid size={{ xs: 12 }}>
          <Card
            sx={{
              padding: '2rem',
              borderRadius: '12px',
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
              borderTop: '6px solid',
              borderTopColor: 'primary.main'
            }}
          >
            <Typography variant='h4' component='h1' color='primary' gutterBottom>
              Terms of Service
            </Typography>
            <Typography variant='body2' color='text.secondary' sx={{ mb: 2 }}>
              Last updated: {LAST_UPDATED}
            </Typography>
            <Divider sx={{ mb: 3 }} />

            <Box sx={{ maxWidth: 800 }}>
              <Typography variant='body1' paragraph>
                Please read these Terms of Service ("Terms") carefully before using waotools.com (the "Site"),
                operated by oNare ("we," "us," or "our").
              </Typography>

              <Section title='1. Acceptance of Terms'>
                <Typography variant='body1' paragraph>
                  By accessing or using the Site, you agree to be bound by these Terms. If you do not agree to these
                  Terms, please do not use the Site.
                </Typography>
              </Section>

              <Section title='2. Permitted Use'>
                <Typography variant='body1' paragraph>
                  WAO Tools is provided free of charge for personal, non-commercial use. You may use the calculators,
                  planners, and reference tools on this Site to assist your own gameplay in War and Order. You may
                  share links to the Site with other players.
                </Typography>
                <Typography variant='body1' paragraph>
                  You may not:
                </Typography>
                <Typography variant='body1' component='div'>
                  <ul>
                    <li>Reproduce, redistribute, or resell the Site's tools or content for commercial purposes</li>
                    <li>Attempt to reverse-engineer, scrape, or systematically download the Site's content</li>
                    <li>Use the Site in any way that disrupts, damages, or impairs its availability</li>
                    <li>Attempt to gain unauthorized access to any part of the Site or its infrastructure</li>
                  </ul>
                </Typography>
              </Section>

              <Section title='3. Intellectual Property'>
                <Typography variant='body1' paragraph>
                  The code, design, text, and tool logic of WAO Tools are the intellectual property of oNare /
                  onaDev, except where otherwise noted. All rights reserved.
                </Typography>
                <Typography variant='body1' paragraph>
                  WAO Tools is an independent, fan-made project. All War and Order game names, trademarks, characters,
                  game mechanics, and assets are the property of their respective owners. WAO Tools does not claim
                  ownership of any game content. See our{' '}
                  <Link href='/disclaimer/' style={{ color: 'inherit' }}>
                    disclaimer
                  </Link>{' '}
                  for more details.
                </Typography>
              </Section>

              <Section title='4. Disclaimer of Warranty'>
                <Typography variant='body1' paragraph>
                  THE SITE AND ALL TOOLS ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTY OF ANY KIND,
                  EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                  PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
                </Typography>
                <Typography variant='body1' paragraph>
                  While we make every effort to maintain accurate data in our calculators and reference tools, we do
                  not guarantee that the calculations, game data, or information presented on this Site are accurate,
                  complete, or up to date. Game mechanics in War and Order change with updates, and tool data may not
                  always reflect the latest game state. Always verify important decisions with in-game information.
                </Typography>
              </Section>

              <Section title='5. Limitation of Liability'>
                <Typography variant='body1' paragraph>
                  TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL WAOTOOLS.COM OR ITS OPERATORS
                  BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT
                  NOT LIMITED TO LOSS OF PROFITS, DATA, OR GOODWILL, ARISING OUT OF OR IN CONNECTION WITH YOUR USE
                  OF THE SITE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                </Typography>
              </Section>

              <Section title='6. Governing Law'>
                <Typography variant='body1' paragraph>
                  These Terms are governed by and construed in accordance with the laws of the Dominican Republic,
                  without regard to its conflict of law provisions.
                </Typography>
              </Section>

              <Section title='7. Changes to Terms'>
                <Typography variant='body1' paragraph>
                  We reserve the right to modify these Terms at any time. Changes will be posted on this page with
                  an updated "Last updated" date. Continued use of the Site after changes are posted constitutes your
                  acceptance of the updated Terms.
                </Typography>
              </Section>

              <Section title='8. Contact'>
                <Typography variant='body1' paragraph>
                  Questions about these Terms? Contact us at:{' '}
                  <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
                </Typography>
              </Section>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </>
  )
}

Terms.noLoadingGate = true

export default Terms

